// extracted by mini-css-extract-plugin
export var section_sns = "official_sns_section-module--section_sns--438b0";
export var section_sns_text = "official_sns_section-module--section_sns_text--d6022";